import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  templateUrl: './error-404.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class Error404Component {
  public currentYear: number = new Date().getFullYear();
}